import { render, staticRenderFns } from "./_footerBanner.vue?vue&type=template&id=43049b08&lang=pug&"
import script from "./_footerBanner.vue?vue&type=script&lang=js&"
export * from "./_footerBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports